<div class="zm-expert-shell">
  <header class="zm-expert-topbar">
    <div>
      <span class="zm-expert-eyebrow">Zone Maker</span>
      <h1>Expert Mode</h1>
    </div>
    <div class="zm-expert-stats">
      <span><strong>{{ polygonCount }}</strong> polygons</span>
      <span><strong>{{ vertexCount }}</strong> points</span>
      <span *ngIf="previewData"><strong>{{ previewData.square_miles || 0 }}</strong> sq mi</span>
    </div>
    <div class="zm-expert-top-actions">
      <button type="button" class="zm-expert-button" routerLink="/zone_maker"><i class="fa-solid fa-layer-group"></i><span>ZIP Mode</span></button>
      <button type="button" class="zm-expert-button zm-expert-button--primary" (click)="previewBoundary()" [disabled]="!canPreview"><i class="fa-solid fa-eye" [class.fa-spin]="previewLoading"></i><span>Preview</span></button>
      <button type="button" class="zm-expert-button zm-expert-button--warning" *ngIf="previewMode" (click)="exitPreviewMode()"><i class="fa-solid fa-eye-slash"></i><span>Exit Preview</span></button>
      <button type="button" class="zm-expert-button zm-expert-button--accent" (click)="saveZone()" [disabled]="!canSave"><i class="fa-solid fa-floppy-disk" [class.fa-spin]="saving"></i><span>{{ editingZoneUuid ? 'Update' : 'Create' }}</span></button>
    </div>
  </header>

  <main class="zm-expert-layout">
    <aside class="zm-expert-sidebar">
      <section class="zm-expert-panel">
        <div class="zm-expert-panel-head">
          <div>
            <span class="zm-expert-eyebrow">Scope</span>
            <h2>Contact</h2>
          </div>
          <div class="zm-expert-toggle">
            <button type="button" [class.is-active]="zoneType === 'customer'" (click)="setZoneType('customer')">Customer</button>
            <button type="button" [class.is-active]="zoneType === 'carrier'" (click)="setZoneType('carrier')">Carrier</button>
          </div>
        </div>

        <div class="zm-expert-field">
          <label for="expert-contact">Contact</label>
          <div class="zm-expert-inline-input">
            <input id="expert-contact" type="text" autocomplete="off" [value]="contactSearchTerm" (input)="onContactSearchChange($any($event.target).value)" (keyup.enter)="applyContactUuid()">
            <button type="button" (click)="applyContactUuid()"><i class="fa-solid fa-arrow-right"></i></button>
          </div>
          <div class="zm-expert-autocomplete" *ngIf="contactOptions.length > 0">
            <button type="button" *ngFor="let option of contactOptions" (click)="selectContact(option)">
              <strong>{{ option.label }}</strong>
              <small>{{ option.value }}</small>
            </button>
          </div>
          <div class="zm-expert-mini-error" *ngIf="contactError">{{ contactError }}</div>
        </div>

        <div class="zm-expert-contact-pill">
          <span>{{ selectedContactLabel }}</span>
          <button type="button" (click)="clearContact()" [disabled]="!selectedContactUuid"><i class="fa-solid fa-xmark"></i></button>
        </div>
      </section>

      <section class="zm-expert-panel">
        <div class="zm-expert-panel-head">
          <div>
            <span class="zm-expert-eyebrow">Saved</span>
            <h2>Zones</h2>
          </div>
          <button type="button" class="zm-expert-icon-button" (click)="loadZones()" [disabled]="!selectedContactUuid || zonesLoading"><i class="fa-solid fa-rotate" [class.fa-spin]="zonesLoading"></i></button>
        </div>

        <div class="zm-expert-zone-list" *ngIf="zones.length; else noExpertZones">
          <button type="button" *ngFor="let zone of zones" [class.is-active]="zone.zone_uuid === editingZoneUuid" (click)="loadZone(zone)">
            <span>
              <strong>{{ zone.name || zone.zone_name }}</strong>
              <small>{{ zone.zone_id || 'No ID' }} / {{ zone.country }}</small>
            </span>
            <i class="fa-solid fa-pen-nib"></i>
          </button>
        </div>
        <ng-template #noExpertZones>
          <div class="zm-expert-empty">{{ selectedContactUuid ? 'No zones loaded' : 'Select a contact' }}</div>
        </ng-template>
      </section>

      <section class="zm-expert-panel">
        <div class="zm-expert-panel-head">
          <div>
            <span class="zm-expert-eyebrow">{{ editingZoneUuid ? 'Editing' : 'Draft' }}</span>
            <h2>Zone</h2>
          </div>
          <button type="button" class="zm-expert-icon-button" (click)="startNewZone()"><i class="fa-solid fa-plus"></i></button>
        </div>

        <div class="zm-expert-grid">
          <div class="zm-expert-field zm-expert-field--wide" *ngIf="editingZoneUuid">
            <label>Zone UUID</label>
            <input type="text" [value]="editingZoneUuid" readonly>
          </div>
          <div class="zm-expert-field zm-expert-field--wide">
            <label for="expert-name">Name</label>
            <input id="expert-name" type="text" [value]="zoneName" (input)="zoneName = $any($event.target).value">
          </div>
          <div class="zm-expert-field">
            <label for="expert-id">ID</label>
            <input id="expert-id" type="text" [value]="zoneId" (input)="zoneId = $any($event.target).value">
          </div>
          <div class="zm-expert-field">
            <label for="expert-country">Country</label>
            <input id="expert-country" type="text" maxlength="3" [value]="country" (input)="country = $any($event.target).value.toUpperCase()">
          </div>
          <div class="zm-expert-field zm-expert-field--wide" *ngIf="zoneType === 'customer'">
            <label for="expert-description">Description</label>
            <textarea id="expert-description" [value]="description" (input)="description = $any($event.target).value"></textarea>
          </div>
          <div class="zm-expert-field zm-expert-field--wide zm-expert-active-row">
            <label>Active</label>
            <div class="zm-expert-toggle">
              <button type="button" [class.is-active]="active" (click)="active = true">Yes</button>
              <button type="button" [class.is-active]="!active" (click)="active = false">No</button>
            </div>
          </div>
        </div>
      </section>


      <section class="zm-expert-panel">
        <div class="zm-expert-panel-head">
          <div>
            <span class="zm-expert-eyebrow">Reference</span>
            <h2>Layers</h2>
          </div>
          <button type="button" class="zm-expert-icon-button" (click)="searchReferenceBoundaries()" [disabled]="referenceLoading"><i class="fa-solid fa-magnifying-glass" [class.fa-spin]="referenceLoading"></i></button>
        </div>

        <div class="zm-expert-layer-picker">
          <button type="button" *ngFor="let option of referenceBoundaryTypes" [class.is-active]="referenceBoundaryType === option.type" (click)="setReferenceBoundaryType(option.type)">
            <i class="fa-solid" [ngClass]="option.icon"></i>
            <span>{{ option.label }}</span>
          </button>
        </div>

        <div class="zm-expert-field">
          <label for="expert-reference-boundary">Search Layer</label>
          <div class="zm-expert-inline-input">
            <input id="expert-reference-boundary" type="text" autocomplete="off" [value]="referenceSearchTerm" (input)="referenceSearchTerm = $any($event.target).value" (keyup.enter)="searchReferenceBoundaries()">
            <button type="button" (click)="searchReferenceBoundaries()" [disabled]="referenceLoading"><i class="fa-solid fa-magnifying-glass" [class.fa-spin]="referenceLoading"></i></button>
          </div>
        </div>

        <div class="zm-expert-reference-summary" *ngIf="selectedReferenceBoundary">
          <strong>{{ selectedReferenceBoundary.display_name || selectedReferenceBoundary.name }}</strong>
          <small>{{ selectedReferenceBoundary.region_code || selectedReferenceBoundary.country_code }} / {{ selectedReferenceBoundary.point_count }} pts</small>
        </div>

        <div class="zm-expert-field zm-expert-reference-select-field">
          <label for="expert-reference-select">Result</label>
          <select id="expert-reference-select" [value]="selectedReferenceBoundaryUuid" (change)="selectReferenceBoundaryUuid($any($event.target).value)" [disabled]="!referenceBoundaries.length || referenceLoading">
            <option value="">{{ referenceBoundaries.length ? 'Select boundary' : 'Search first' }}</option>
            <option *ngFor="let boundary of referenceBoundaries" [value]="boundary.reference_boundary_uuid">{{ boundary.display_name || boundary.name }} / {{ boundary.region_code || boundary.country_code }} / {{ boundary.point_count }} pts</option>
          </select>
        </div>

        <div class="zm-expert-empty" *ngIf="!referenceBoundaries.length">No results loaded</div>

        <div class="zm-expert-action-grid zm-expert-reference-actions">
          <button type="button" class="zm-expert-button zm-expert-button--warning" (click)="useReferenceBoundary()" [disabled]="!selectedReferenceBoundary || referenceLoading"><i class="fa-solid fa-magnet"></i><span>Snap Draft</span></button>
          <button type="button" class="zm-expert-button" (click)="clearReferenceBoundary()" [disabled]="!selectedReferenceBoundary"><i class="fa-solid fa-eye-slash"></i><span>Clear</span></button>
        </div>
      </section>

      <section class="zm-expert-panel">
        <div class="zm-expert-panel-head">
          <div>
            <span class="zm-expert-eyebrow">Geometry</span>
            <h2>Editor</h2>
          </div>
          <div class="zm-expert-toggle">
            <button type="button" [class.is-active]="mode === 'pan'" (click)="setMode('pan')"><i class="fa-solid fa-hand"></i></button>
            <button type="button" [class.is-active]="mode === 'draw'" (click)="setMode('draw')"><i class="fa-solid fa-draw-polygon"></i></button>
            <button type="button" [class.is-active]="mode === 'edit'" (click)="setMode('edit')"><i class="fa-solid fa-up-down-left-right"></i></button>
          </div>
        </div>

        <div class="zm-expert-action-grid">
          <button type="button" class="zm-expert-button" (click)="startNewPolygon()"><i class="fa-solid fa-plus"></i><span>Polygon</span></button>
          <button type="button" class="zm-expert-button" (click)="finishPolygon()"><i class="fa-solid fa-check"></i><span>Finish</span></button>
          <button type="button" class="zm-expert-button" (click)="undoPoint()" [disabled]="!vertexCount"><i class="fa-solid fa-rotate-left"></i><span>Undo Point</span></button>
          <button type="button" class="zm-expert-button" (click)="removeSelectedVertex()" [disabled]="!selectedVertex"><i class="fa-solid fa-minus"></i><span>Point</span></button>
          <button type="button" class="zm-expert-button zm-expert-button--danger" (click)="clearGeometry()" [disabled]="!vertexCount"><i class="fa-solid fa-trash"></i><span>Clear</span></button>
        </div>

        <div class="zm-expert-grid zm-expert-grid--cleanup">
          <div class="zm-expert-field">
            <label for="expert-hole">Fill Holes Sq Mi</label>
            <input id="expert-hole" type="number" min="0" max="10000" step="0.05" [value]="minHoleSquareMiles" (input)="onMinHoleSquareMilesChange($any($event.target).value)">
          </div>
          <div class="zm-expert-field">
            <label for="expert-simplify">Simplify Deg</label>
            <input id="expert-simplify" type="number" min="0" max="0.1" step="0.0001" [value]="simplifyToleranceDegrees" (input)="onSimplifyToleranceChange($any($event.target).value)">
          </div>
        </div>

        <div class="zm-expert-action-grid">
          <button type="button" class="zm-expert-button zm-expert-button--primary" (click)="previewBoundary()" [disabled]="!canPreview"><i class="fa-solid fa-eye" [class.fa-spin]="previewLoading"></i><span>Preview</span></button>
          <button type="button" class="zm-expert-button" (click)="validateBoundary()" [disabled]="!canPreview || validating"><i class="fa-solid fa-shield-halved" [class.fa-spin]="validating"></i><span>Validate</span></button>
          <button type="button" class="zm-expert-button zm-expert-button--warning" (click)="usePreviewGeometry()" [disabled]="!previewData"><i class="fa-solid fa-wand-magic-sparkles"></i><span>Use Preview</span></button>
          <button type="button" class="zm-expert-button" *ngIf="previewMode" (click)="exitPreviewMode()"><i class="fa-solid fa-eye-slash"></i><span>Exit Preview</span></button>
        </div>
      </section>

      <section class="zm-expert-panel" *ngIf="previewData || previewWarnings.length || validationErrors.length">
        <div class="zm-expert-panel-head">
          <div>
            <span class="zm-expert-eyebrow">Report</span>
            <h2>Preview</h2>
          </div>
        </div>
        <div class="zm-expert-report" *ngIf="previewData">
          <span><strong>{{ previewData.square_miles || 0 }}</strong> sq mi</span>
          <span><strong>{{ previewData.geometry.cleaned_point_count || 0 }}</strong> points</span>
          <span><strong>{{ previewData.geometry.filled_hole_count || 0 }}</strong> holes filled</span>
          <span><strong>{{ previewData.overlaps.length }}</strong> overlaps</span>
        </div>
        <div class="zm-expert-message is-warning" *ngFor="let warning of previewWarnings">{{ warning }}</div>
        <div class="zm-expert-message is-error" *ngFor="let error of validationErrors">{{ error }}</div>
      </section>
    </aside>

    <section class="zm-expert-map-panel">
      <div #mapBox class="zm-expert-map"></div>
      <div class="zm-expert-danger-alarm" *ngIf="overlapZones.length" role="alert" aria-live="assertive">
        <div class="zm-expert-danger-alarm__headline">
          <i class="fa-solid fa-robot"></i>
          <span>Danger</span>
        </div>
        <strong>Boundary overlap</strong>
        <small>{{ overlapZoneNames }}</small>
      </div>
      <div class="zm-expert-map-footer">
        <span>{{ mode | uppercase }}</span>
        <span>{{ selectedContactUuid || 'No contact' }}</span>
        <span *ngIf="editingZoneUuid">{{ editingZoneUuid }}</span>
      </div>
    </section>
  </main>
</div>
